<script setup lang="ts">
import type { ArticleSectionStoryblok } from '~/component-types-sb'

const props = defineProps<{ blok: ArticleSectionStoryblok }>()
const milkyBg = computed(() => props.blok.milky_bg ? 'bg-milky-200' : '')
</script>

<template>
  <div :class="milkyBg">
    <div v-editable="props.blok">
      <div class="md:w-2/3 rounded-md overflow-hidden ">
        <div class="md:px-6 px-5 md:py-8 py-10">
          <h2 :id="props.blok._uid" class="md:text-h2 text-m-h2" v-html="props.blok.title" />
          <div class="py-4">
            <span class="prose prose-stone leading-normal md:leading-normal md:prose-lg" v-html="renderRichText(props.blok.description)" />
          </div>
          <div class="flex flex-col gap-4">
            <div v-if="renderRichText(props?.blok?.pros)" class="flex flex-nowrap gap-2.5">
              <div class="mt-0.5">
                ✅
              </div>
              <span class="prose prose-stone leading-normal md:leading-normal md:prose-lg" v-html="renderRichText(props?.blok?.pros)" />
            </div>
            <div v-if="renderRichText(props?.blok?.cons)" class="flex flex-nowrap gap-2.5">
              <div class="mt-0.5">
                ❌
              </div>
              <span class="prose prose-stone leading-normal md:leading-normal md:prose-lg" v-html="renderRichText(props?.blok?.cons)" />
            </div>
          </div>
          <NuxtImg v-if="props.blok.image" :alt="props.blok.image.alt"  placeholder provider="storyblok" class="md:ml-6 ml-0 mt-6 md:mt-10 w-full md:w-2/3 rounded-md" :src="props.blok.image?.filename" alt="Card img" />
        </div>
      </div>
    </div>
  </div>
</template>
